import React from 'react';
import { FormField } from '../../FormField/FormField';
import { UserDisplay } from '../../UserDisplay/UserDisplay';
import { UsersSelect } from '../../UsersSelect/UsersSelect';
import { ReservationType } from '../../../types/reservationType';
import { User } from '../../../types/user';
import { ReservationFormFieldProps } from '../types';

interface Props extends Omit<ReservationFormFieldProps, 'setFormFields'> {
  isModifying: boolean;
  showRequiredFields: boolean;
  reservationType: ReservationType;
  onChange: (user: User | undefined) => void;
}

/** The employee that gives the session. */
export const EmployeeField = ({ form, validationErrors, isModifying, showRequiredFields, reservationType, onChange }: Props) => {
  return (
    <FormField
      labelTitle='Empleado'
      elementId='reservation-employee'
      fullWidth
      error={validationErrors?.user}
      required={showRequiredFields}
    >
      {isModifying ? (
        <UsersSelect
          id='reservation-employee'
          value={form?.user?.id}
          feature={reservationType?.features.receive}
          onChange={onChange}
          error={validationErrors?.user}
        />
      ) : (
        <UserDisplay name={form?.user?.name} surnames={form?.user?.surnames} avatarUrl={form?.user?.avatarUrl} />
      )}
    </FormField>
  );
};
